/**
 * Component to protect routes based on user role
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from '../../hooks/useUserRole';
import { UserRole } from '../../types/roles';

interface RequireRoleProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
  fallback?: string;
}

export function RequireRole({ 
  children, 
  allowedRoles, 
  fallback = '/' 
}: RequireRoleProps) {
  const { role, isLoading } = useUserRole();

  // Show loading state while checking role
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Check if user has required role
  if (!allowedRoles.includes(role)) {
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}

